export default __webpack_public_path__ + "static/media/URUZ.af7d2f5a.png";